import React from 'react'
import styled from 'styled-components'

import { Button, Icon } from 'components/atoms'

export const Cluster = styled.div`
  .title {
    color: ${ (props) => props.theme.colors['icon-grau2'] };
    font-weight: bold;
    margin-top: 20px;
    line-height: 1.44;
    padding: 0 10px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      padding: 0 20px;
    }
  }
`

export const MatchIcon = styled((props) => <Icon { ...props } />)`
  color: ${ (props) => props.theme.colors['icon-grau2'] };
  margin-right: 11px;
`

export const ShowAllMatchesButton = styled((props) => <Button { ...props } />)`
  width: 100%;
  text-decoration: underline;
`

export const Match = styled.div`
  display: flex;
  cursor: pointer;
  padding: 10px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    padding: 10px 20px;
  }

  &:hover {
    background: ${ (props) => props.theme.colors['hintergrund-prio3'] };
  }

  &:focus {
    background: ${ (props) => props.theme.colors['hintergrund-prio3'] };
  }
`
